module.exports = __webpack_public_path__ + "static/media/bullock-cart.ca70f868.png";